"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVNode = isVNode;
exports.getFirstComponentChild = getFirstComponentChild;

require("core-js/modules/es.array.filter.js");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _util = require("./util");

function isVNode(node) {
  return node !== null && (0, _typeof2["default"])(node) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
}

function getFirstComponentChild(children) {
  return children && children.filter(function (c) {
    return c && c.tag;
  })[0];
}